module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_right_arrow.60642.png";